import { render, staticRenderFns } from "./product-item-modal.vue?vue&type=template&id=63f51266&scoped=true&lang=pug"
import script from "./product-item-modal.js?vue&type=script&lang=js&external"
export * from "./product-item-modal.js?vue&type=script&lang=js&external"
import style0 from "./product-item-modal.vue?vue&type=style&index=0&id=63f51266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f51266",
  null
  
)

export default component.exports